module.exports = __webpack_public_path__ + "img/benefit_lakers-all-access.3a35961a.jpg";